import { jsx as _jsx } from "react/jsx-runtime";
import Draft from "draft-js";
import { Typography } from "@mui/material";
import Immutable from "immutable";
export const blockRenderMap = Draft.DefaultDraftBlockRenderMap.merge(Immutable.Map({
    "header-one": {
        wrapper: _jsx(Typography, { variant: "h2" }),
    },
    "header-two": {
        wrapper: _jsx(Typography, { variant: "h3" }),
    },
    "header-three": {
        wrapper: _jsx(Typography, { variant: "h4" }),
    },
}));
//# sourceMappingURL=blockRenderMap.js.map